export const CARD_STATUS = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  STOLEN: 'stolen',
  LOST: 'lost',
  FROZEN: 'frozen',
  CLOSED_BY_CUSTOMER: 'closed_by_customer',
  SUSPECTED_FRAUD: 'suspected_fraud'
};

export const CARD_TYPE = {
  BUSINESS_DEBIT_CARD: 'business_debit_card',
  BUSINESS_VIRTUAL_DEBIT_CARD: 'business_virtual_debit_card'
};

export const CARD_PIN_STATUS = {
  SET: 'set',
  NOTSET: 'notset'
};

export const CREATE_CARD_ERROR = {
  title: 'Error',
  description: 'Failed to request new card'
};

export const PIN_ACTION = {
  ACTIVATION: 'activation',
  RESET: 'reset'
};

export const PIN_ACTION_RESULT = {
  SUCCESS: 'success',
  FAILURE: 'failure'
};

export const DISABLED_PIN_CARD_BANNER = {
  TITLE: 'You’ve exceeded the maximum number of PIN reset attempts allowed within a 24-hr period.',
  SUBTITLE: 'Please wait for 24 hrs or contact customer support.'
};

export const RESET_PIN_MAX_ATTEMPTS = 9;
